import React from 'react';

/* ==================================================================
   CompanyCard
   ------------------------------------------------------------------
   Compact opening card used in the scroll story and the hero
   ecosystem: an open role at a company, nothing more.
   ================================================================== */

export default function CompanyCard({ role, company, tone = 'plain', index = 0, className = '' }) {
  return (
    <article
      className={`hs-opening hs-opening--${tone} ${className}`.trim()}
      style={{ '--hs-i': index }}
    >
      <span className="hs-opening__dot" aria-hidden="true" />
      <div className="hs-opening__text">
        <p className="hs-opening__role">{role}</p>
        {company && <p className="hs-opening__company">{company}</p>}
      </div>
    </article>
  );
}
